import { ButtonWithGAClickButton, Section, SectionSubTitle } from 'common/components';
import { ADPLATFORM_TRAINING_ELEMENT_BLOCK } from 'landings/adplatform-training/adplatform-training-constants';
import React from 'react';
import {
  adplatformTrainingFirstStepSectionButton,
  adplatformTrainingFirstStepSectionTitle,
} from './adplatform-training-first-step-section-styles';

export const AdplatformTrainingFirstStepSection: React.FC = () => (
  <Section>
    <SectionSubTitle className={adplatformTrainingFirstStepSectionTitle} margin="m">
      Сделайте первый шаг к&nbsp;эффективному продвижению
    </SectionSubTitle>
    <ButtonWithGAClickButton
      className={adplatformTrainingFirstStepSectionButton}
      variant="accent"
      elementBlock={ADPLATFORM_TRAINING_ELEMENT_BLOCK}
      elementName="Сделайте первый шаг к эффективному продвижению"
      elementText="Узнать про рекламную платформу"
      href="/promotion/"
      adaptive={false}>
      Узнать про рекламную платформу
    </ButtonWithGAClickButton>
  </Section>
);
